export const REVIEW_FILTER_PARAMS = [
  'category_id',
  'filter_by_brand_locale',
  'media_reviews_first',
  'page',
  'query',
  'review_tag_type_ids',
  'scores',
  'sort',
  'user_height',
  'user_weight',
  'with_media',
  'with_video'
];

export const PRODUCT_POPUP_PARAMS = ['category_id'];

export const POPUP_PER = 7;
